import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';
import {
  DataTable,
  DataTableItem,
  Loader,
  SectionHeader,
} from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  AccountingGroupDetails,
  AccountingsQueryFilters,
  addSellAccountingGroupAsync,
  getAllSellAccountingGroupsAsync,
  getAllSellVatsAsync,
  selectSellAccountingGroups,
  selectSellAccountingGroupsLoadingStatus,
} from './accountingSlice';
import { LOADING_STATUS } from '../../common/constants';

function SellAccountingGroups() {
  const history = useNavigate();
  const dispatch = useAppDispatch();
  const [hasSearchBeenMade, setHasSearchBeenMade] = useState<boolean>(false);
  const accountingGroups = useAppSelector(selectSellAccountingGroups);
  const accountingGroupsLoadingStatus = useAppSelector(
    selectSellAccountingGroupsLoadingStatus,
  );
  const [filtering, setFiltering] = useState<AccountingsQueryFilters>({
    pageSize: 200,
    pageNumber: 1,
    culture: 'fi_FI',
  });
  const [accountingGroupsListItems, setAccountingGroupsListItems] = useState<
    DataTableItem[]
  >([]);

  // calls actual search, which calls internal getAllAccountingGroupsAsync Async
  // and that is then routed to backend
  const doSearch = () => {
    dispatch(getAllSellAccountingGroupsAsync(filtering));
  };

  useEffect(() => {
    doSearch();
    setHasSearchBeenMade(true);
  }, []);

  useEffect(() => {
    if (accountingGroups && accountingGroups.length > 0) {
      const formattedAccountingGroupsList: DataTableItem[] = [];
      accountingGroups?.forEach(item => {
        formattedAccountingGroupsList.push({
          ItemId: item.id,
          Items: [item.name],
          Url: `/accounting/sellaccountinggroups/${item.id}`,
        });
      });
      setAccountingGroupsListItems(formattedAccountingGroupsList);
    }
  }, [accountingGroups]);

  const handleAddClick = () => {
    const data = {
      id: '',
      name: '',
    } as AccountingGroupDetails;
    dispatch(addSellAccountingGroupAsync(data)).then(res => {
      history(`/accounting/sellaccountinggroups/${res.payload}`);
    });
  };

  // draws elements to browser
  return (
    <>
      <Helmet>
        <title>Kirjanpitotilit - Haku</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Kirjanpito ja Alv-määritykset']}
          Title="Kirjanpitotilit - Haku"
        />

        <Loader
          IsLoading={accountingGroupsLoadingStatus === LOADING_STATUS.LOADING}
        />

        {accountingGroupsLoadingStatus === LOADING_STATUS.IDLE &&
          accountingGroupsListItems.length > 0 && (
            <DataTable Header={['Nimi']} Items={accountingGroupsListItems} />
          )}

        {accountingGroupsLoadingStatus === LOADING_STATUS.IDLE &&
          accountingGroupsListItems.length < 1 &&
          hasSearchBeenMade && <p>Ei kirjanpitotilejä.</p>}
      </Container>
    </>
  );
}

export default SellAccountingGroups;
